import { Components, ColorProfiles } from '@powdr/constants';

// Color Profiles
const {
  BASE, PRIMARY, SECONDARY, TERTIARY, QUATERNARY,
} = ColorProfiles;

export const config = {
  [Components.HEADER]: BASE,
  [Components.MAIN_NAV]: BASE,
  [Components.MEGA_NAV]: BASE,
  [Components.MOBILE_NAV]: PRIMARY,
  [Components.ECOMMERCE_BANNER]: PRIMARY,
  [Components.WEATHER_FEED]: SECONDARY,
  [Components.PROMOTIONS_FEED]: TERTIARY,
  [Components.PROMOTIONS]: BASE,
  [Components.ALERT_BAR]: PRIMARY,
  [Components.STICKY_NAV]: SECONDARY,
  [Components.TERTIARY_NAV]: PRIMARY,
  [Components.LEVELS_MODAL]: BASE,
  [Components.FOOTER]: PRIMARY,
  [Components.FOOTER_NAV]: PRIMARY,
  [Components.PARTNERS]: PRIMARY,
  [Components.COPYRIGHT]: TERTIARY,
  [Components.MODAL]: BASE,
  layout: {
    headerHeight: 90,
    headerHeightMobile: 70,
    headerLogoContainerWidth: 250,
    headerFeedContainer: 250,
  },
};
